function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.027 1.624V14.7139H15.0059V16H0.995544V14.7139H1.97457V1.624C1.97554 0.727492 2.70062 0.000970009 3.59536 0H12.4063C13.301 0.00105799 14.026 0.727528 14.027 1.624ZM11.8667 2.13715H3.86669V14.7086H11.8667V2.13715Z",
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.89045 11.7712V14.7139H3.25806V1.624C3.25823 1.43751 3.40903 1.28634 3.59515 1.28608H12.4062C12.5923 1.28634 12.7431 1.43751 12.7433 1.624V14.7139H10.1109V11.7712H5.89045ZM8.82742 13.0573V14.7139H7.17405V13.0573H8.82742ZM4.85035 2.36262H7.13015V4.64242H4.85035V2.36262ZM11.1924 2.36263H8.91258V4.64242H11.1924V2.36263ZM4.85036 5.38853H7.13016V7.66833H4.85036V5.38853ZM11.1924 5.38853H8.91258V7.66833H11.1924V5.38853ZM4.85036 8.456H7.13016V10.7358H4.85036V8.456ZM11.1924 8.456H8.91258V10.7358H11.1924V8.456Z",
  fill: "#99A6B0"
});

const SvgMeduimGray = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeduimGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meduim-gray.c6d6399a.svg";
export { ForwardRef as ReactComponent };